/* eslint-disable */

import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import i18n from "@/i18n";

Vue.use(Vuex);

const api = process.env.VUE_APP_ACCOUNT_API_URL;
const merch_api = process.env.VUE_APP_MERCH_API_URL;
axios.defaults.withCredentials = true;

function actionLoggerPlugin(store) {
  if (process.env.NODE_ENV !== "production") {
    store.subscribeAction(({ type, payload }, state) => {
      console.log(
        `Dispatching %cACTION:%c "${type}" with ${JSON.stringify(payload)}`,
        "background: #2DA00C; color: #fff",
        "background: #222; color: #fff"
      );
    });
  }
}

export default new Vuex.Store({
  state: {
    frontendVersion: "v2",
    game: "bg3",
    launchableGame: null,
    continueButton: false,
    cacheVersion: null,
    isLoading: false,
    activeStep: 1,
    user: null,
    initPlatform: "",
    launcherVersion: null,
    language: "en",
    platformSession: {
      platform: null,
      token: null,
      gameId: null,
    },
    renderingEngine: "dx11",
    system: null,
    architecture: "x86_64",
    friendsOpened: false,
    merchProducts: null,
    areModsInstalled: false,
  },

  mutations: {
    setLoading(state, value) {
      state.isLoading = value;
    },

    setFrontendVersion(state, value) {
      state.frontendVersion = value;
    },

    setDisplayContinue(state, value) {
      state.continueButton = value;
    },

    setLaunchableGame(state, value) {
      state.launchableGame = value.toLowerCase();
    },

    setGame(state, value) {
      console.log("set game from STORE", value);
      state.game = value;
    },

    setCacheVersion(state, value) {
      state.cacheVersion = value;
    },

    setStep(state, step) {
      state.activeStep = step;
    },

    setUser(state, data) {
      state.user = data;
    },

    setPlatform(state, value) {
      state.user.platforms[value] = true;
    },

    removeUser(state) {
      state.user = null;
    },

    setInitPlatform(state, value) {
      state.initPlatform = value;
    },

    setLauncherVersion(state, value) {
      state.launcherVersion = value;
    },

    setPlatformSession(state, value) {
      state.platformSession = value;
    },

    setLanguage(state, value) {
      state.language = value;
      i18n.locale = value;
    },
    setRenderingEngine(state, value) {
      state.renderingEngine = value;
    },
    setSystem(state, value) {
      state.system = value;
    },
    setArchitecture(state, value) {
      state.architecture = value;
    },

    toggleFriends(state, value) {
      state.friendsOpened = value;
    },

    setMerchProducts(state, products) {
      state.merchProducts = products;
    },

    setMods(state, areMods) {
      if (typeof areMods === "string") {
        state.areModsInstalled = JSON.parse(areMods.toLowerCase());
      } else {
        state.areModsInstalled = areMods;
      }
    },
  },

  actions: {
    showErrorToast({ commit }, msg) {
      Vue.toasted.error(msg);
    },

    setLoading({ commit }, value) {
      commit("setLoading", value);
    },

    setGame({ commit }, value) {
      commit("setGame", value);
    },

    setLaunchableGame({ commit }, value) {
      commit("setLaunchableGame", value);
    },

    getCacheVersion({ commit }) {
      const version = window.location.search;
      commit("setCacheVersion", version);
    },

    setStep({ commit }, step) {
      commit("setStep", step);
    },

    setUser({ state, commit }, data) {
      if (data) {
        commit("setUser", data);
      } else {
        commit("removeUser");
      }
    },

    setPlatform({ state, commit }, value) {
      commit("setPlatform", value);
    },

    setRenderingEngine({ state, commit }, value) {
      commit("setRenderingEngine", value);
    },

    setSystem({ state, commit }, value) {
      commit("setSystem", value);
    },

    setArchitecture({ state, commit }, value) {
      commit("setArchitecture", value);
    },

    toggleFriends({ state, commit }, value) {
      commit("toggleFriends", value);
    },

    async getNotice({ state }) {
      try {
        const version = state.cacheVersion;

        const notices = await axios({
          url: `${process.env.VUE_APP_API_HOST}/cache/launchers.json${version}`,
          method: "GET",
          withCredentials: false,
        });
        return notices.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getMerchProducts({ commit }) {
      try {
        const products = await axios.get(
          `${merch_api}/public-api/launcher/products`
        );
        commit("setMerchProducts", products.data.data);
      } catch (error) {
        console.log(error);
      }
    },

    async login({ commit, state }, payload) {
      try {
        // const data = await axios.post(`${api}api/account/login`, payload);
        const data = await axios({
          url: `${api}api/account/login`,
          method: "POST",
          data: payload,
          withCredentials: true,
        });

        return data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loginMfaSms({ state, commit }, payload) {
      try {
        const res = await axios.post(
          `${api}api/account/mfa/submitcode`,
          payload
        );
        return res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loginMfaTotp({ state, dispatch }, payload) {
      try {
        const res = await axios.post(
          `${api}api/account/mfa/submitcode`,
          payload
        );
        return res.data;
      } catch (error) {
        console.log(error);
      }
    },

    async logout({ state, commit }, payload) {
      try {
        return await axios.post(`${api}api/account/logout`, payload);
      } catch (error) {}
    },

    async create({ state, commit }, payload) {
      try {
        return await axios.post(`${api}api/account/create`, payload);
      } catch (error) {}
    },
    /******************************************************************************************************************
     *                          Run Game                                                                              *
     ******************************************************************************************************************/
    async runGame({ state }, value) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        if (state.system === "macos" && state.architecture !== "arm64") {
          console.log("run game without params");
          launcher.runGame();
        } else {
          console.log(`run game with param - ${value}`);
          launcher.runGame(value);
        }
      } catch (error) {
        console.log("error: " + error);
      }
    },
    async continueGame({ state }, value) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        if (state.system === "macos" && state.architecture !== "arm64") {
          console.log("continue game without params");
          launcher.continueGame();
        } else {
          console.log(`continue game with param - ${value}`);
          launcher.continueGame(value);
        }
      } catch (error) {
        console.log("error: " + error);
      }
    },

    /******************************************************************************************************************
     *                          Communication                                                                         *
     ******************************************************************************************************************/
    async displayContinue({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const isContinueButtonVisible = await launcher.displayContinue();

        commit("setDisplayContinue", isContinueButtonVisible);
      } catch (error) {
        console.log("error: " + error);
      }
    },
    async getLaunchableGame({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");

        if (typeof launcher.getGameName === "function") {
          const game = await launcher.getGameName();
          console.log("setLaunchableGame", game);
          commit("setLaunchableGame", game);
        } else {
          commit("setFrontendVersion", "v1");
        }
      } catch (error) {
        console.log("error: " + error);
      }
    },
    async getLanguage({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const lang = await launcher.getLanguageIso();
        console.log("setLanguage", lang);
        commit("setLanguage", lang);
      } catch (error) {
        console.log("error: " + error);
      }
    },

    async getGraphicsBackend({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const rendering = await launcher.getGraphicsBackend();
        console.log("rendering engine from native: ", rendering);

        commit("setRenderingEngine", rendering);
      } catch (error) {
        console.log("error: " + error);
      }
    },

    async getPlatform({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const platform = await launcher.getPlatform();

        commit("setInitPlatform", platform);
      } catch (error) {
        commit("setInitPlatform", "steam");
      }
      // return launcher.getPlatform();
      //dodac metode do ustawienia state => initPlatform
    },

    async getVersion({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const version = await launcher.getVersion();
        commit("setLauncherVersion", version);
      } catch (error) {}
    },

    async getSystem({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const system = await launcher.getSystem();
        commit("setSystem", system);
      } catch (error) {}
    },

    async getArchitecture({ commit }) {
      try {
        console.log("GET ARCHITECTURE");
        await CefSharp.BindObjectAsync("launcher");
        const arch = await launcher.getArchitecture();
        console.log("SET ARCHITECTURE", arch);
        commit("setArchitecture", arch);
      } catch (error) {}
    },

    async getPlatformSession({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const platform = await launcher.getUserPlatform();
        const token = await launcher.getUserToken();
        const gameId = await launcher.getUserGameId();
        console.log(
          "CefSharp platform (PLAT, GAMEID, TOK): ",
          platform,
          gameId,
          token
        );

        commit("setInitPlatform", platform);
        commit("setPlatformSession", {
          platform,
          token,
          gameId,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async completeOnboarding({ commit, state }) {
      //should leave or remove?
      commit("setStep", 1);

      await CefSharp.BindObjectAsync("launcher");

      return launcher.completeOnboarding();
    },

    async webpageReady() {
      await CefSharp.BindObjectAsync("launcher");
      return launcher.webpageReady();
    },

    async areModsInstalled({ commit }) {
      try {
        await CefSharp.BindObjectAsync("launcher");
        const areMods = await launcher.areModsInstalled();
        console.log("areModsInstalled", areMods);

        commit("setMods", areMods);
      } catch (error) {
        console.log("error: " + error);
      }
    },

    /******************************************************************************************************************
     *                              account connect                                                                   *
     ******************************************************************************************************************/

    // Steam connect:
    async steamConnect({ state, commit }, payload) {
      try {
        const data = await axios.get(`${api}api/account/steam/connect`, {
          params: payload,
        });
        if (data.data.redirect) {
          document.location = data.data.redirect;
        }
      } catch (error) {}
    },

    //Galaxy connect:
    async galaxyConnect({ state, commit }, payload) {
      try {
        const data = await axios.get(`${api}api/account/galaxy/connect`, {
          params: payload,
        });
        if (data.data.redirect) {
          document.location = data.data.redirect;
        }
      } catch (error) {}
    },
    /******************************************************************************************************************
     *                              account link using platform                                                                   *
     ******************************************************************************************************************/

    // Steam connect:
    async steamAutoLink({ state, commit }, payload) {
      try {
        return await axios.get(`${api}api/account/steam/launcher-link`, {
          params: payload,
        });
      } catch (error) {
        return Promise.reject(new Error(error));
      }
    },

    // Galaxy connect:
    async galaxyAutoLink({ state, commit }, payload) {
      try {
        return await axios.get(`${api}api/account/galaxy/launcher-link`, {
          params: payload,
        });
      } catch (error) {
        return Promise.reject(new Error(error));
      }
    },
  },
  modules: {},

  plugins: [
    createPersistedState({
      key: "larian-launcher",
      paths: ["user"],
    }),
  ],
});
